(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dual-cta"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.dual-cta').forEach(function (root) {
    var modal = root.querySelector('[data-quote-modal-local]');
    var openBtn = root.querySelector('[data-quote-open]');
    if (!modal || !openBtn) return;
    function open() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('quote-modal-open');
      var focusable = modal.querySelector('input, select, textarea');
      if (focusable) focusable.focus({ preventScroll: true });
    }
    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('quote-modal-open');
    }
    openBtn.addEventListener('click', open);
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-quote-close-local]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
    /* Na verzending (hash = form-id) de popup met succesmelding heropenen */
    var form = modal.querySelector('form');
    if (form && window.location.hash === '#' + form.id) open();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Roterende topbar-aankondigingen */
  document.querySelectorAll('[data-announcements]').forEach(function (rotator) {
    var items = rotator.querySelectorAll('.topbar__announcement');
    if (items.length < 2) return;
    var current = 0, paused = false;
    rotator.addEventListener('mouseenter', function () { paused = true; });
    rotator.addEventListener('mouseleave', function () { paused = false; });
    setInterval(function () {
      if (paused) return;
      items[current].classList.remove('is-active');
      current = (current + 1) % items.length;
      items[current].classList.add('is-active');
    }, 5000);
  });

  /* Live zoeksuggesties (Shopify predictive search) */
  document.querySelectorAll('[data-predictive-input]').forEach(function (input) {
    var panel = input.closest('.header-search__panel');
    var results = panel ? panel.querySelector('[data-predictive-results]') : null;
    if (!results) return;
    var debounceTimer, lastQuery = '';

    function money(value) {
      var num = parseFloat(value);
      if (isNaN(num)) return '';
      return num.toLocaleString(document.documentElement.lang || 'es', { style: 'currency', currency: 'EUR' });
    }

    function render(products, query) {
      results.innerHTML = '';
      if (!products.length) {
        var empty = document.createElement('p');
        empty.className = 'header-search__empty';
        empty.textContent = results.dataset.emptyText.replace('[Q]', query);
        results.appendChild(empty);
        results.hidden = false;
        return;
      }
      products.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'header-search__result';
        a.href = p.url;
        var thumb = document.createElement('span');
        thumb.className = 'header-search__result-thumb';
        if (p.image) {
          var img = document.createElement('img');
          img.src = p.image;
          img.alt = '';
          img.loading = 'lazy';
          thumb.appendChild(img);
        }
        var title = document.createElement('span');
        title.className = 'header-search__result-title';
        title.textContent = p.title;
        var price = document.createElement('span');
        price.className = 'header-search__result-price';
        price.textContent = money(p.price);
        a.appendChild(thumb); a.appendChild(title); a.appendChild(price);
        results.appendChild(a);
      });
      var all = document.createElement('a');
      all.className = 'header-search__result header-search__result--all';
      all.href = results.dataset.searchUrl + '?q=' + encodeURIComponent(query);
      all.textContent = results.dataset.allText + ' →';
      results.appendChild(all);
      results.hidden = false;
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(debounceTimer);
      if (query.length < 2) {
        results.hidden = true;
        results.innerHTML = '';
        lastQuery = '';
        return;
      }
      debounceTimer = setTimeout(function () {
        if (query === lastQuery) return;
        lastQuery = query;
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (input.value.trim() !== query) return;
            render(data.resources.results.products || [], query);
          })
          .catch(function () { results.hidden = true; });
      }, 250);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hero').forEach(function (root) {
    var modal = root.querySelector('[data-quote-modal-local]');
    var openBtn = root.querySelector('[data-quote-open]');
    if (!modal || !openBtn) return;
    function open() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('quote-modal-open');
      var focusable = modal.querySelector('input, select, textarea');
      if (focusable) focusable.focus({ preventScroll: true });
    }
    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('quote-modal-open');
    }
    openBtn.addEventListener('click', open);
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-quote-close-local]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
    /* Na verzending (hash = form-id) de popup met succesmelding heropenen */
    var form = modal.querySelector('form');
    if (form && window.location.hash === '#' + form.id) open();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m2-calculator"] && !Shopify.designMode) return;
  try {
    
  /* Gedelegeerde events: overleven her-renders van de sectie (theme-editor)
     en binden dus niet aan losse elementen die vervangen kunnen worden. */
  (function () {
    function calcMoney(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'es', { style: 'currency', currency: 'EUR' });
    }
    function calcFmt(n) {
      return (Math.round(n * 10) / 10).toString().replace('.', ',');
    }
    function calcData(calc) {
      var dataEl = calc.querySelector('[data-m2-data]');
      if (!dataEl) return null;
      try {
        return JSON.parse(dataEl.textContent);
      } catch (err) {
        console.error('[m2-calc] JSON ongeldig:', err);
        return null;
      }
    }

    /* Wisselgeld-logica: grootste rol eerst, rest aanvullen met kleinere
       maten; de kleinste maat rondt naar boven af (nooit een tekort). */
    function greedyCombo(target, rolls) {
      var combo = [], remaining = target;
      rolls.forEach(function (roll, i) {
        if (remaining <= 0) return;
        var isSmallest = i === rolls.length - 1;
        var count = isSmallest ? Math.ceil(remaining / roll.m2) : Math.floor(remaining / roll.m2);
        if (count > 0) {
          combo.push({ roll: roll, count: count });
          remaining -= count * roll.m2;
        }
      });
      return combo;
    }

    function comboStats(combo) {
      var price = 0, coverage = 0, units = 0;
      combo.forEach(function (line) {
        price += line.count * line.roll.price_cents;
        coverage += line.count * line.roll.m2;
        units += line.count;
      });
      return { price: price, coverage: coverage, units: units };
    }

    function calculate(calc) {
      var input = calc.querySelector('[data-m2-input]');
      var result = calc.querySelector('[data-m2-result]');
      var data = calcData(calc);
      if (!input || !result || !data) return;
      var margin = 1 + (parseFloat(calc.dataset.margin) || 0) / 100;
      var area = parseFloat(String(input.value).replace(',', '.'));
      if (!area || area <= 0) { input.focus(); return; }
      var target = area * margin;
      var rolls = data.rolls
        .filter(function (r) { return r.available && r.m2 > 0; })
        .sort(function (a, b) { return b.m2 - a.m2; });
      if (!rolls.length) return;

      /* Kandidaat 1: wisselgeld-combinatie. Kandidaten 2..n: één enkele
         rolmaat naar boven afgerond — de goedkoopste dekkende optie wint. */
      var best = greedyCombo(target, rolls);
      var bestStats = comboStats(best);
      rolls.forEach(function (roll) {
        var count = Math.ceil(target / roll.m2);
        var candidate = [{ roll: roll, count: count }];
        var stats = comboStats(candidate);
        if (stats.price < bestStats.price || (stats.price === bestStats.price && stats.coverage < bestStats.coverage)) {
          best = candidate;
          bestStats = stats;
        }
      });

      var list = calc.querySelector('[data-m2-combo]');
      list.innerHTML = '';
      best.forEach(function (line) {
        var li = document.createElement('li');
        li.textContent = data.strings.roll_line
          .replace('[N]', line.count)
          .replace('[R]', line.roll.title === 'Default Title' ? data.product_title : line.roll.title)
          .replace('[C]', calcFmt(line.count * line.roll.m2));
        list.appendChild(li);
      });

      calc.querySelector('[data-m2-total]').textContent = data.strings.total
        .replace('[C]', calcFmt(bestStats.coverage))
        .replace('[T]', calcMoney(bestStats.price));
      result.hidden = false;

      var addBtn = calc.querySelector('[data-m2-add]');
      if (addBtn) {
        addBtn.hidden = false;
        addBtn.querySelector('[data-m2-add-label]').textContent = data.strings.add.replace('[N]', bestStats.units);
      }
      /* Combinatie bewaren op het element zelf, zodat een her-render hem reset */
      calc.__combo = best;

      window.__revesurM2 = area;
      if (window.RevesurTierHint) window.RevesurTierHint(0, area);
    }

    document.addEventListener('click', function (e) {
      var calcBtn = e.target.closest('[data-m2-button]');
      if (calcBtn) {
        calculate(calcBtn.closest('[data-m2-calc]'));
        return;
      }
      var addBtn = e.target.closest('[data-m2-add]');
      if (addBtn) {
        var calc = addBtn.closest('[data-m2-calc]');
        var combo = calc && calc.__combo;
        if (!combo) return;
        var items = combo.map(function (line) {
          return { id: line.roll.id, quantity: line.count };
        });
        var original = addBtn.innerHTML;
        addBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
              el.classList.remove('is-empty');
              el.classList.remove('bump');
              void el.offsetWidth;
              el.classList.add('bump');
            });
            addBtn.innerHTML = addBtn.dataset.addedLabel;
            setTimeout(function () { addBtn.disabled = false; addBtn.innerHTML = original; }, 2200);
          })
          .catch(function () {
            addBtn.disabled = false;
            addBtn.innerHTML = original;
          });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var input = e.target.closest('[data-m2-input]');
      if (input) {
        e.preventDefault();
        calculate(input.closest('[data-m2-calc]'));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.querySelectorAll('[data-cart-quote-modal]').forEach(function (modal) {
    function open() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('quote-modal-open');
      var focusable = modal.querySelector('input, select, textarea');
      if (focusable) focusable.focus({ preventScroll: true });
    }
    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('quote-modal-open');
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-quote-open]')) { open(); return; }
      if (e.target.closest('[data-cart-quote-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
    /* Na verzending (hash = form-id) de popup met succesmelding heropenen */
    var form = modal.querySelector('form');
    if (form && window.location.hash === '#' + form.id) open();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.querySelectorAll('[data-filter-form]').forEach(function (form) {
    /* Mobiele filter-drawer openen/sluiten */
    var drawer = form.querySelector('[data-facets]');
    var openButton = form.querySelector('[data-facets-open]');
    var closeButton = form.querySelector('[data-facets-close]');
    function setDrawer(open) {
      if (!drawer) return;
      drawer.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    }
    if (openButton) openButton.addEventListener('click', function () { setDrawer(true); });
    if (closeButton) closeButton.addEventListener('click', function () { setDrawer(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setDrawer(false);
    });

    /* Checkbox-filters en sortering direct toepassen — behalve in de open
       drawer: daar verzamelt de klant filters en past ze toe met "Ver resultados" */
    form.addEventListener('change', function (e) {
      if (drawer && drawer.classList.contains('is-open') && e.target.matches('.facet__option input')) return;
      if (e.target.matches('.facet__option input') || e.target.matches('[data-filter-submit]')) {
        form.submit();
      }
    });
    /* Slechts één facet-dropdown tegelijk open; klik erbuiten sluit */
    var facets = form.querySelectorAll('[data-facet]');
    facets.forEach(function (facet) {
      facet.addEventListener('toggle', function () {
        if (!facet.open) return;
        facets.forEach(function (other) { if (other !== facet) other.open = false; });
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-facet]')) {
        facets.forEach(function (facet) { facet.open = false; });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-main]').forEach(function (root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var selects = root.querySelectorAll('[data-option-select]');
    var idInput = root.querySelector('[data-variant-id]');
    var buyBtn = root.querySelector('[data-buy-button]');
    var buyLabel = root.querySelector('[data-buy-label]');
    var priceEl = root.querySelector('[data-price]');
    var unitEl = root.querySelector('[data-unit-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var mainImg = root.querySelector('[data-gallery-main]');
    var soldOutText = buyLabel ? buyLabel.textContent.trim() : '';

    function currentVariant() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      if (!chosen.length) return data.variants[0];
      return data.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
    }

    function setMainImage(src) {
      var img = mainImg && mainImg.querySelector('img');
      if (!img || !src) return;
      mainImg.classList.add('is-loading');
      var pre = new Image();
      pre.onload = function () {
        img.src = src;
        img.removeAttribute('srcset');
        mainImg.classList.remove('is-loading');
      };
      pre.src = src;
    }

    function applyVariant(v) {
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (compareEl) {
        compareEl.textContent = v.compare_at_price || '';
        compareEl.style.display = v.compare_at_price ? '' : 'none';
      }
      if (unitEl) {
        if (v.unit_price) {
          unitEl.style.display = '';
          unitEl.textContent = (v.m2_per_unit ? v.m2_per_unit + ' m² — ' : '') + v.unit_price + '/' + (v.unit_ref || 'm²');
        } else {
          unitEl.style.display = 'none';
        }
      }
      if (buyBtn) {
        buyBtn.disabled = !v.available;
        if (buyLabel) {
          if (v.available && buyBtn.dataset.availableLabel) buyLabel.textContent = buyBtn.dataset.availableLabel;
          if (!v.available) buyLabel.textContent = soldOutText;
        }
      }
      if (v.media_src) setMainImage(v.media_src);
      window.__revesurVariant = v;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
      document.dispatchEvent(new CustomEvent('revesur:variant', { detail: v }));
    }

    if (buyBtn && buyLabel && !buyBtn.disabled) buyBtn.dataset.availableLabel = buyLabel.textContent.trim();
    selects.forEach(function (s) {
      s.addEventListener('change', function () { applyVariant(currentVariant()); });
    });
    window.__revesurVariant = currentVariant() || data.variants[0];

    root.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        root.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        setMainImage(thumb.dataset.src);
      });
    });

    /* Offerte-popup: alle #presupuesto-knoppen openen de modal i.p.v. te scrollen */
    var quoteModal = root.querySelector('[data-quote-modal]');
    if (quoteModal) {
      function openQuoteModal() {
        quoteModal.classList.add('is-open');
        quoteModal.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('quote-modal-open');
        var focusable = quoteModal.querySelector('input, select, textarea, button:not([data-quote-close])');
        if (focusable) focusable.focus({ preventScroll: true });
      }
      function closeQuoteModal() {
        quoteModal.classList.remove('is-open');
        quoteModal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('quote-modal-open');
      }

      document.addEventListener('click', function (e) {
        var trigger = e.target.closest('a[href*="#presupuesto"]');
        if (trigger) {
          e.preventDefault();
          /* voorinvullen vanuit de staffelhint-link (cantidad/m2) */
          var url = new URL(trigger.href, window.location.origin);
          var qty = url.searchParams.get('cantidad');
          var m2 = url.searchParams.get('m2') || window.__revesurM2 || '';
          var qtyField = quoteModal.querySelector('[name="contact[cantidad]"]');
          var m2Field = quoteModal.querySelector('[name="contact[m2]"]');
          if (qtyField && qty) qtyField.value = qty;
          if (m2Field && m2) m2Field.value = m2;
          openQuoteModal();
          return;
        }
        if (e.target.closest('[data-quote-close]')) closeQuoteModal();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && quoteModal.classList.contains('is-open')) closeQuoteModal();
      });

      /* Alleen na een verzonden OFFERTE uit deze popup (hash = modal-form-id)
         de popup met succesmelding heropenen — niet na andere formulieren */
      var modalForm = quoteModal.querySelector('form');
      if (modalForm && window.location.hash === '#' + modalForm.id) openQuoteModal();
    }
  });

  /* Envío estimado: telt werkdagen vanaf nu, met besteltijd-cutoff */
  document.querySelectorAll('[data-shipping-estimate]').forEach(function (el) {
    var target = el.querySelector('[data-shipping-dates]');
    if (!target) return;
    var minDays = parseInt(el.dataset.minDays, 10) || 0;
    var maxDays = parseInt(el.dataset.maxDays, 10);
    if (isNaN(maxDays) || maxDays < minDays) maxDays = minDays;
    var cutoff = parseInt(el.dataset.cutoff, 10);
    var start = new Date();
    if (!isNaN(cutoff) && start.getHours() >= cutoff) start.setDate(start.getDate() + 1);
    function addBusinessDays(base, days) {
      var d = new Date(base);
      while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
      for (var added = 0; added < days;) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) added++;
      }
      return d;
    }
    var lang = document.documentElement.lang || 'es';
    function fmt(d) { return d.toLocaleDateString(lang, { weekday: 'short', day: 'numeric', month: 'short' }); }
    var from = addBusinessDays(start, minDays);
    var to = addBusinessDays(start, maxDays);
    if (from.toDateString() === to.toDateString()) {
      target.textContent = target.dataset.templateSingle.replace('[from]', fmt(from));
    } else {
      target.textContent = target.dataset.templateRange.replace('[from]', fmt(from)).replace('[to]', fmt(to));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  /* "Ver todas las reseñas": klapt de verborgen reviews uit en verdwijnt daarna */
  document.querySelectorAll('[data-reviews-more]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var section = btn.closest('.reviews');
      if (section) {
        section.querySelectorAll('[data-review-extra]').forEach(function (card) { card.hidden = false; });
      }
      btn.remove();
    });
  });

  document.querySelectorAll('[data-review-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = btn.parentElement.querySelector('[data-review-form]');
      if (!form) return;
      var open = form.hidden;
      form.hidden = !open;
      btn.setAttribute('aria-expanded', String(open));
      if (open) {
        var first = form.querySelector('input[type="text"], input:checked');
        if (first) first.focus({ preventScroll: true });
      }
    });
  });
  /* Alleen na een verzonden REVIEW (hash = #ReviewForm) het formulier
     met succesmelding open tonen — niet na andere contactformulieren */
  if (window.location.hash === '#ReviewForm') {
    document.querySelectorAll('[data-review-form]').forEach(function (form) {
      form.hidden = false;
      var btn = form.parentElement.querySelector('[data-review-toggle]');
      if (btn) btn.setAttribute('aria-expanded', 'true');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usp-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.usp-bar').forEach(function (root) {
    var strip = root.querySelector('[data-usp-strip]');
    var dots = root.querySelectorAll('[data-usp-dot]');
    if (!strip || !dots.length) return;

    function step() {
      var items = strip.children;
      if (items.length > 1) return items[1].offsetLeft - items[0].offsetLeft;
      return strip.clientWidth || 1;
    }

    function update() {
      var index = Math.round(strip.scrollLeft / step());
      index = Math.max(0, Math.min(dots.length - 1, index));
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
    }

    strip.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        strip.scrollTo({ left: i * step(), behavior: 'smooth' });
      });
    });
    update();
  });

  } catch(e) { console.error(e); }
})();
})();
